<template>
  <div>
    <van-row gutter="2" style="margin: 10px">
      <van-col span="24">
        <span style="font-size: smaller;color: red">选择你要接的任务</span>
      </van-col>
    </van-row>
    <van-row gutter="2">
      <van-col span="24">
        <van-divider dashed style="margin: 1px"></van-divider>
      </van-col>
    </van-row>
    <van-pull-refresh
        v-model="isLoading"
        success-text="刷新成功"
        @refresh="onRefresh">
        <div v-for="(cardItem, index) in taskList" :key="index">
          <anchor-order-item-component :card-data="cardItem" :key="index" @reciveOrder="reciveOrder"></anchor-order-item-component>
        </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import {queryAnchorTaskOrders, reciveOrderWithAnchor} from "../../api/system/mobile_taskorder";
import {MessageBox} from "mint-ui";
import AnchorOrderItemComponent from "../../components/AnchorOrderItemComponent";

export default {
  name: "TaskBrocastList",
  components: {
    AnchorOrderItemComponent
  },
  data() {
    return {
      isLoading: false,
      refreshing:false,
      finished: true,
      taskList: [
        [
          {
            taskItemKey: "序号",
            taskItemVal: "1"
          },
          {
            taskItemKey: "任务ID",
            taskItemVal: "xxxx"
          },
          {
            taskItemKey: "店铺",
            taskItemVal: "xxxxx"
          },
          {
            taskItemKey: "任务标题",
            taskItemVal: "xxxxxx"
          },
          {
            taskItemKey: "任务类型",
            taskItemVal: "xxxxx"
          },
          {
            taskItemKey: "返款方式",
            taskItemVal: "xxxx"
          },
          {
            taskItemKey: "本金返款",
            taskItemVal: "平台"
          },
          {
            taskItemKey: "数量",
            taskItemVal: "10"
          },
          {
            taskItemKey: "发布时间",
            taskItemVal: "2021-03-31 10:30:00"
          },
          {
            taskItemKey: "备注",
            taskItemVal: "xxxx"
          },
        ],
        [
          {
            taskItemKey: "序号",
            taskItemVal: "1"
          },
          {
            taskItemKey: "任务ID",
            taskItemVal: "xxxx"
          },
          {
            taskItemKey: "店铺",
            taskItemVal: "xxxxx"
          },
          {
            taskItemKey: "任务标题",
            taskItemVal: "xxxxxx"
          },
          {
            taskItemKey: "任务类型",
            taskItemVal: "xxxxx"
          },
          {
            taskItemKey: "返款方式",
            taskItemVal: "xxxx"
          },
          {
            taskItemKey: "本金返款",
            taskItemVal: "平台"
          },
          {
            taskItemKey: "数量",
            taskItemVal: "10"
          },
          {
            taskItemKey: "发布时间",
            taskItemVal: "2021-03-31 10:30:00"
          },
          {
            taskItemKey: "备注",
            taskItemVal: "xxxx"
          },
        ],
        [
          {
            taskItemKey: "序号",
            taskItemVal: "1"
          },
          {
            taskItemKey: "任务ID",
            taskItemVal: "xxxx"
          },
          {
            taskItemKey: "店铺",
            taskItemVal: "xxxxx"
          },
          {
            taskItemKey: "任务标题",
            taskItemVal: "xxxxxx"
          },
          {
            taskItemKey: "任务类型",
            taskItemVal: "xxxxx"
          },
          {
            taskItemKey: "返款方式",
            taskItemVal: "xxxx"
          },
          {
            taskItemKey: "本金返款",
            taskItemVal: "平台"
          },
          {
            taskItemKey: "数量",
            taskItemVal: "10"
          },
          {
            taskItemKey: "发布时间",
            taskItemVal: "2021-03-31 10:30:00"
          },
          {
            taskItemKey: "备注",
            taskItemVal: "xxxx"
          },
        ],
        [
          {
            taskItemKey: "序号",
            taskItemVal: "1"
          },
          {
            taskItemKey: "任务ID",
            taskItemVal: "xxxx"
          },
          {
            taskItemKey: "店铺",
            taskItemVal: "xxxxx"
          },
          {
            taskItemKey: "任务标题",
            taskItemVal: "xxxxxx"
          },
          {
            taskItemKey: "任务类型",
            taskItemVal: "xxxxx"
          },
          {
            taskItemKey: "返款方式",
            taskItemVal: "xxxx"
          },
          {
            taskItemKey: "本金返款",
            taskItemVal: "平台"
          },
          {
            taskItemKey: "数量",
            taskItemVal: "10"
          },
          {
            taskItemKey: "发布时间",
            taskItemVal: "2021-03-31 10:30:00"
          },
          {
            taskItemKey: "备注",
            taskItemVal: "xxxx"
          },
        ],
        [
          {
            taskItemKey: "序号",
            taskItemVal: "1"
          },
          {
            taskItemKey: "任务ID",
            taskItemVal: "xxxx"
          },
          {
            taskItemKey: "店铺",
            taskItemVal: "xxxxx"
          },
          {
            taskItemKey: "任务标题",
            taskItemVal: "xxxxxx"
          },
          {
            taskItemKey: "任务类型",
            taskItemVal: "xxxxx"
          },
          {
            taskItemKey: "返款方式",
            taskItemVal: "xxxx"
          },
          {
            taskItemKey: "本金返款",
            taskItemVal: "平台"
          },
          {
            taskItemKey: "数量",
            taskItemVal: "10"
          },
          {
            taskItemKey: "发布时间",
            taskItemVal: "2021-03-31 10:30:00"
          },
          {
            taskItemKey: "备注",
            taskItemVal: "xxxx"
          },
        ],
      ],
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.$emit("titleChange", "任务大厅");
    this.getData();
  },
  methods: {
    reciveOrder(orderInfo){
      console.log(orderInfo)
      reciveOrderWithAnchor(orderInfo).then(res=>{
        if (res.success){
          this.getData();
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        })
      });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.isLoading = true;
      this.onLoad();
    },
    onLoad(){
      if (this.refreshing) {
        this.refreshing = false;
      }
      if (!this.finished){
        this.pagination.pageNum = this.pagination.pageNum + 1;
      }
      queryAnchorTaskOrders(this.pagination).then(res=>{
        if (res.success){
          this.taskList.push(...res.data.records);
        }
        this.isLoading = false;
        this.finished = true;
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        })
      })
    },
    getData(){
      queryAnchorTaskOrders(this.pagination).then(res=>{
        if (res.success){
          this.taskList = res.data.records;
        }
        this.loading = false;
        this.finished = true;
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
